import { Category, CategoryServiceFactory, CategoryConfiguration, LogLevel } from "typescript-logging";
import { ErrorDetails } from "../controls/errorPanel";

CategoryServiceFactory.setDefaultConfiguration(new CategoryConfiguration(LogLevel.Info));

export const Core = new Category("Core");

export function logError(error: ErrorDetails) {
    Core.error(error.title, error.details);
}